import { FC } from 'react';

import { PopularQueriesSkeleton } from './PopularQueriesSkeleton';
import { ProductCardsSkeleton } from './ProductCardsSkeleton';
import { SkeletonGroupsWrapper } from './Skeletons.styles';

type Props = {
    isNavBar?: boolean;
};

export const NoSuggestionsSkeleton: FC<Props> = ({ isNavBar = false }) => {
    return (
        <SkeletonGroupsWrapper $isNavBar={isNavBar} $isNoSuggestions={true}>
            <PopularQueriesSkeleton />
            <ProductCardsSkeleton />
        </SkeletonGroupsWrapper>
    );
};
